import Loadable from 'react/components/loadable';

const RestoreEventModal = Loadable({
  loader: () => import('react/pages/events/restore_event_modal/restore_event_modal'),
  type: 'modal',
});

angular.module('gym').value('RestoreEventModal', RestoreEventModal);
